import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n          border-bottom: 1px dashed currentColor;\n          transition: border-color 250ms ease 0s;\n\n          &:hover {\n            border-color: transparent;\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n          border-color: transparent;\n\n          &:hover {\n            border-color: transparent;\n          }\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { Button } from "@miro-site/core";
import styled, { css } from "styled-components";
var SecondaryLink = styled(Button).withConfig({
    componentId: "sc-3b60d1cf-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        color: theme.templates.colors.secondary40,
        ":focus": _object_spread({}, theme.focus.outlines.withOffset),
        fontSize: 14,
        lineHeight: 20
    });
}, function(param) {
    var $isDashed = param.$isDashed;
    return $isDashed ? css(_templateObject()) : css(_templateObject1());
});
export default SecondaryLink;
